import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ToastConfig } from '../toast-config';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  private readonly defaultDurationMs = 5000;
  private readonly animationDurationMs = 300;
  private hideTimer: ReturnType<typeof setTimeout> | undefined;
  private showTimer: ReturnType<typeof setTimeout> | undefined;

  toastConfigSubject: BehaviorSubject<ToastConfig | null> =
    new BehaviorSubject<ToastConfig | null>(null);
  toastConfig$: Observable<ToastConfig | null> =
    this.toastConfigSubject.asObservable();

  setToast(val: ToastConfig | null) {
    if (this.hideTimer) {
      clearTimeout(this.hideTimer);
      this.hideTimer = undefined;
    }

    // Cancel any pending toast that hasn't been shown yet
    // This prevents a previous toast (e.g. from the interceptor) from flashing
    // before a newer toast (e.g. from a component error handler) replaces it
    if (this.showTimer) {
      clearTimeout(this.showTimer);
      this.showTimer = undefined;
    }

    // Reset to null first to ensure repeated toasts with same content are shown again
    if (val && this.toastConfigSubject.value !== null) {
      this.toastConfigSubject.next(null);
    }

    // Use setTimeout to ensure the null is processed before showing new toast
    this.showTimer = setTimeout(() => {
      this.showTimer = undefined;
      this.toastConfigSubject.next(val);

      if (val) {
        const duration = val.durationMs ?? this.defaultDurationMs;
        this.hideTimer = setTimeout(() => {
          this.toastConfigSubject.next(null);
          this.hideTimer = undefined;
        }, duration);
      }
    }, 0);
  }
}
